module.exports = __webpack_public_path__ + "img/roles-logo.17859968.svg";